import { type MetaFunction } from "react-router"
import { APP_NAME } from "#app/utils/constants"
import { generateMeta } from "#app/utils/meta"

export const meta: MetaFunction = () => {
	return generateMeta({
		title: `Sobre Nosotros - ${APP_NAME}`,
		description:
			"Conoce la historia de Greta's Patchwork. Productos de patchwork hechos a mano con pasión, dedicación y atención al detalle.",
		canonical: "/about",
	})
}

export default function AboutRoute() {
	return <div>About page</div>
}
